import Image from 'next/image';

export const ProductsIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/products/${icon}.svg`}
    alt={icon}
    width={70}
    height={70}
    quality="100"
    priority
  />
);

export const ProductsPNGIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/products/${icon}.png`}
    alt={icon}
    width={70}
    height={70}
    quality="100"
    priority
  />
);

const SolutionsPNGIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/solutions/${icon}.png`}
    alt={icon}
    width={70}
    height={70}
    quality="100"
    priority
  />
);

const CustomersIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/customers/${icon}.svg`}
    alt={icon}
    width={48}
    height={48}
    quality="100"
    priority
  />
);

const ResourcesPNGIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/resources/${icon}.png`}
    alt={icon}
    width={32}
    height={32}
    quality="100"
    priority
    className="p-[4px] sm:p-1 w-full h-full"
  />
);

const CompanyPNGIcon = ({ icon }) => (
  <Image
    src={`/static/images/global/header/company/${icon}.png`}
    alt={icon}
    width={32}
    height={32}
    quality="100"
    priority
    className="p-[4px] sm:p-1 w-full h-full"
  />
);

const dropdownProducts = {
  section1: {
    title: 'Build AI',
    row1: {
      content: [
        {
          href: '/data-engine',
          icon: <ProductsIcon icon="labeling" />,
          title: 'Scale Data Engine',
          text: 'Annotate, curate, and collect data',
          type: 'big'
        }
      ]
    },
    row2: {
      title: 'Specializations:',
      subContent: [
        {
          href: '/self-driving-cars',
          icon: <ProductsPNGIcon icon="automotive" />,
          title: 'Automotive',
          text: 'Unlock L2 to L5 autonomy',
          type: 'small'
        },
        {
          href: '/rlhf',
          icon: <ProductsPNGIcon icon="generative-ai" />,
          title: 'Generative AI & RLHF',
          text: 'Power generative AI models',
          type: 'small'
        }
      ]
    }
  },
  section2: {
    title: 'Apply AI',
    row1: {
      content: [
        {
          href: '/generative-ai-platform',
          icon: <ProductsIcon icon="catalog" />,
          title: 'Scale Generative AI Platform',
          text: 'Full-stack generative AI',
          type: 'big'
        }
      ]
    },
    row2: {
      title: 'Apps:',
      subContent: [
        {
          href: '/forge',
          icon: <ProductsPNGIcon icon="forge" />,
          title: 'Scale Forge',
          text: 'AI powered marketing suite',
          type: 'small'
        },
        {
          href: '/ecommerce-ai',
          icon: <ProductsPNGIcon icon="e-commerce" />,
          title: 'Scale E-Commerce AI',
          text: 'Enhance E-commerce data',
          type: 'small'
        }
      ]
    },
    row3: {
      content: [
        {
          href: '/donovan',
          icon: <ProductsIcon icon="donovan" />,
          title: 'Scale Donovan',
          text: 'AI solutions for Federal',
          type: 'big'
        }
      ]
    }
  },
  section3: {
    title: 'Developers',
    row1: {
      content: [
        {
          href: '/spellbook',
          icon: <ProductsIcon icon="language" />,
          title: 'Scale Spellbook',
          text: 'The platform for LLM apps',
          type: 'big'
        }
      ]
    }
  }
};

const dropdownSolutions = {
  industries: {
    title: 'Industries',
    content: [
      {
        href: '/retail',
        icon: <SolutionsPNGIcon icon="retail" />,
        title: 'Retail & eCommerce',
        type: 'big'
      },
      {
        href: '/defense',
        icon: <SolutionsPNGIcon icon="government" />,
        title: 'Defense',
        type: 'big'
      },
      {
        href: '/logistics',
        icon: <SolutionsPNGIcon icon="logistics" />,
        title: 'Logistics',
        type: 'big'
      }
    ]
  },
  useCases: {
    title: 'Use Cases',
    content: [
      {
        href: '/self-driving-cars',
        icon: <SolutionsPNGIcon icon="autonomous-vehicles" />,
        title: 'Autonomous Vehicles',
        type: 'big'
      },
      {
        href: '/robotics',
        icon: <SolutionsPNGIcon icon="robotics" />,
        title: 'Robotics',
        type: 'big'
      },
      {
        href: '/ar-vr',
        icon: <SolutionsPNGIcon icon="ar-vr" />,
        title: 'AR/VR',
        type: 'big'
      },
      {
        href: '/content-language',
        icon: <SolutionsPNGIcon icon="content-language" />,
        title: 'Content & Language',
        type: 'big'
      },
      {
        href: '/smart-port',
        icon: <SolutionsPNGIcon icon="smart-port" />,
        title: 'Smart Port Lab',
        type: 'big'
      },
      {
        href: '/donovan',
        icon: <SolutionsPNGIcon icon="federal-llms" />,
        title: 'Federal LLMs',
        type: 'big'
      }
    ]
  }
};

const dropdownCustomers = {
  generativeAi: [
    {
      href: '/blog/how-to-label-1m-data-points-week',
      icon: <CustomersIcon icon="open-ai" />,
      title: 'Open AI'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="co:here" />,
      title: 'Co:here'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="adept" />,
      title: 'Adept'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="carperai" />,
      title: 'CarperAI'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="stability-ai" />,
      title: 'Stability AI'
    }
  ],
  government: [
    {
      href: '/customers',
      icon: <CustomersIcon icon="usarmy" />,
      title: 'US Army'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="airforce" />,
      title: 'US Airforce'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="defense-innovation-unit" />,
      title: `Defense 
Innovation Unit`
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="cdao" />,
      title: 'CDAO'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="oshkosh" />,
      title: 'Oshkosh'
    }
  ],
  enterprises: [
    {
      href: '/customers',
      icon: <CustomersIcon icon="microsoft" />,
      title: 'Microsoft'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="meta" />,
      title: 'Meta'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="gm" />,
      title: 'GM'
    },
    {
      href: '/customers/toyota',
      icon: <CustomersIcon icon="toyota" />,
      title: 'Toyota'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="etsy" />,
      title: 'Etsy'
    }
  ],
  startups: [
    {
      href: '/customers/brex',
      icon: <CustomersIcon icon="brex" />,
      title: 'Brex'
    },
    {
      href: '/customers/flexport',
      icon: <CustomersIcon icon="flexport" />,
      title: 'Flexport'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="instacart" />,
      title: 'Instacart'
    },
    {
      href: '/customers',
      icon: <CustomersIcon icon="faire" />,
      title: 'Faire'
    },
    {
      href: '/customers/opensea',
      icon: <CustomersIcon icon="opensea" />,
      title: 'OpenSea'
    }
  ]
};

const dropdownCustomersMobile = [
  {
    href: '/blog/how-to-label-1m-data-points-week',
    icon: <CustomersIcon icon="open-ai" />,
    title: 'Open AI'
  },
  {
    href: '/customers',
    icon: <CustomersIcon icon="microsoft" />,
    title: 'Microsoft'
  },
  {
    href: '/customers/toyota',
    icon: <CustomersIcon icon="toyota" />,
    title: 'Toyota'
  },
  {
    href: '/customers/brex',
    icon: <CustomersIcon icon="brex" />,
    title: 'Brex'
  },
  {
    href: '/customers/flexport',
    icon: <CustomersIcon icon="flexport" />,
    title: 'Flexport'
  },
  {
    href: '/customers/opensea',
    icon: <CustomersIcon icon="opensea" />,
    title: 'OpenSea'
  }
];

const dropdownResources = [
  {
    href: '/resources',
    icon: <ResourcesPNGIcon icon="resources" />,
    title: 'Resource Library'
  },
  {
    href: '/blog',
    icon: <ResourcesPNGIcon icon="blog" />,
    title: 'Blog'
  },
  {
    href: '/docs',
    icon: <ResourcesPNGIcon icon="documentation" />,
    title: 'Documentation'
  },
  {
    href: '/events',
    icon: <ResourcesPNGIcon icon="events" />,
    title: 'Events'
  },
  {
    href: '/guides',
    icon: <ResourcesPNGIcon icon="guides" />,
    title: 'Guides'
  },
  {
    href: '/open-av-datasets',
    icon: <ResourcesPNGIcon icon="open-datasets" />,
    title: 'Open Datasets'
  },
  {
    href: '/ai-readiness-report',
    icon: <ResourcesPNGIcon icon="ai-readiness-report" />,
    title: 'AI Readiness Report 2023'
  }
];

const dropdownCompany = [
  {
    href: '/about',
    icon: <CompanyPNGIcon icon="about" />,
    title: 'About'
  },
  {
    href: '/sales',
    icon: <CompanyPNGIcon icon="sales" />,
    title: 'Contact'
  },
  {
    href: '/careers',
    icon: <CompanyPNGIcon icon="careers" />,
    title: 'Careers'
  },
  {
    href: '/security',
    icon: <CompanyPNGIcon icon="security" />,
    title: 'Security'
  },
  {
    href: '/legal/terms',
    icon: <CompanyPNGIcon icon="legal" />,
    title: 'Legal'
  }
];

export const dropdownItems = {
  products: dropdownProducts,
  solutions: dropdownSolutions,
  customers: { desktop: dropdownCustomers, mobile: dropdownCustomersMobile },
  resources: dropdownResources,
  company: dropdownCompany
};

export default dropdownItems;
